import { takeLatest } from 'redux-saga/effects';
import {
  handleFetchPincodeInfo, handleSaveNomineeDetails,
  handleSkipNomineeDetails,
} from './nomineeDetailsFormHandlers';
import { fetchPincodeInfo, saveNomineeDetails, skipNomineeDetails } from './nomineeDetailsFormSlice';

export function* saveNomineeDetailsSaga() {
  yield takeLatest(saveNomineeDetails.type, handleSaveNomineeDetails);
}

export function* skipNomineeDetailsSaga() {
  yield takeLatest(skipNomineeDetails.type, handleSkipNomineeDetails);
}

export function* fetchPincodeInfoSaga() {
  yield takeLatest(fetchPincodeInfo.type, handleFetchPincodeInfo);
}
